import { CampaignStatusLabels } from './rewardsConstants';

export const minorToMajor = minorUnits => {
  if (minorUnits === null || minorUnits === undefined || minorUnits === '') {
    return '';
  }
  return (Number(minorUnits) / 100).toFixed(2);
};

export const majorToMinor = majorUnits => {
  if (majorUnits === null || majorUnits === undefined || majorUnits === '') {
    return null;
  }
  return Math.round(Number(majorUnits) * 100);
};

export const formatBudgetDisplay = (spentMinor, budgetMinor) => {
  if (!budgetMinor) {
    return '—';
  }
  return `${minorToMajor(spentMinor || 0)} / ${minorToMajor(budgetMinor)}`;
};

export const formatBudgetPercent = (spentMinor, budgetMinor) => {
  if (!budgetMinor) {
    return 0;
  }
  return Math.min(100, Math.round(((spentMinor || 0) / budgetMinor) * 100));
};

export const formatUtcDate = dateStr => {
  if (!dateStr) {
    return '—';
  }
  const d = new Date(dateStr);
  return d.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
};

export const normalizeFormDate = dateInput => {
  if (!dateInput) {
    return null;
  }
  if (typeof dateInput === 'string') {
    return dateInput;
  }
  if (dateInput.date && typeof dateInput.date === 'string') {
    return dateInput.date;
  }
  if (dateInput instanceof Date) {
    return `${dateInput.getMonth() + 1}/${dateInput.getDate()}/${dateInput.getFullYear()}`;
  }
  return null;
};

export const formDateToUtc = dateInput => {
  const dateStr = normalizeFormDate(dateInput);
  if (!dateStr) {
    return null;
  }
  const parts = dateStr.split('/');
  if (parts.length !== 3) {
    return null;
  }
  const month = parts[0].padStart(2, '0');
  const day = parts[1].padStart(2, '0');
  const year = parts[2];
  return `${year}-${month}-${day}T00:00:00Z`;
};

export const endFormDateToUtc = dateInput => {
  const dateStr = normalizeFormDate(dateInput);
  if (!dateStr) {
    return null;
  }
  const parts = dateStr.split('/');
  if (parts.length !== 3) {
    return null;
  }
  const month = parts[0].padStart(2, '0');
  const day = parts[1].padStart(2, '0');
  const year = parts[2];
  return `${year}-${month}-${day}T23:59:59Z`;
};

export const defaultFormDates = () => {
  const startDate = new Date();
  const endDate = new Date();
  endDate.setMonth(endDate.getMonth() + 3);
  const fmt = d => `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
  return { startDate: fmt(startDate), endDate: fmt(endDate) };
};

export const getStatusLabel = status => {
  if (typeof status === 'string') {
    return status;
  }
  return CampaignStatusLabels[status] || 'Unknown';
};

export const buildQueryString = params => {
  const parts = Object.keys(params)
    .filter(key => params[key] !== '' && params[key] !== null && params[key] !== undefined)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`);
  return parts.length ? `?${parts.join('&')}` : '';
};
